/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OutputGetAllClientDto } from '../../models/output-get-all-client-dto';

export interface ClientManagementGetClientByIdPost$Params {
  clientId?: number;
}

export function clientManagementGetClientByIdPost(http: HttpClient, rootUrl: string, params?: ClientManagementGetClientByIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<OutputGetAllClientDto>> {
  const rb = new RequestBuilder(rootUrl, clientManagementGetClientByIdPost.PATH, 'post');
  if (params) {
    rb.query('clientId', params.clientId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OutputGetAllClientDto>;
    })
  );
}

clientManagementGetClientByIdPost.PATH = '/ClientManagement/GetClientById';
